import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-bold"]

import { computed } from "vue";
import { FakeStatus, Status } from "@/types";
import { useProjectStore } from "@/stores/projects";
import commonTools from "@/tools/common-tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusYearTotal',
  props: {
    status: {},
    year: {},
    bold: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const projectsStore = useProjectStore();

const sum = computed(() => {
    const v = projectsStore.getTotalsForStatus(props.status.id, props.year);
    return commonTools.currencyFormat(v) + " EUR";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "StatusYearTotal",
    "data-bold": _ctx.bold
  }, [
    _createElementVNode("div", null, _toDisplayString(_ctx.status.title), 1),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "StatusYearTotal__line" }, null, -1)),
    _createElementVNode("div", null, _toDisplayString(sum.value), 1)
  ], 8, _hoisted_1))
}
}

})